export default __webpack_public_path__ + "static/media/gcoin-bag.5f39ead0.png";